<template>
  <v-layout d-flex justify-center align-center flex-column wrap-reverse pt-2 pb-2 ma-2 class="card-counter">
    <span class="title">{{this.attendeeType.inputDisplayText}}</span>
    <span class="d-flex align-center">
      <v-btn fab small :disabled="!quantity" color="primary" @click="remove">
        <v-icon>remove</v-icon>
      </v-btn>
      <span class="px-7 headline grey--text text--darken-1" :class="{ 'text--darken-3': !!quantity }">{{quantity}}</span>
      <v-btn fab small :disabled="maxAttendeesPerReservation" color="primary" @click="add">
        <v-icon>add</v-icon>
      </v-btn>
    </span>
    <span class="caption mt-3" :class="!maxAttendeesPerReservation ? 'hidden' : ''">
      {{this.$t('activity_reservation.max_attendee_type').replace('{maxAttendeesPerReservation}', this.attendeeType.maxAttendeesPerReservation)}}
    </span>
  </v-layout>
</template>

<script>
import ReservationMixins from '@/mixins/Reservation'

export default {
  props: {
    attendeeType: { required: true },
  },
  computed: {
    quantity: {
      get () {
        const stateAttendees = this.numeralAttendees.find((numeralAttendee) => numeralAttendee.id === this.attendeeType.id)
          ? this.numeralAttendees.find((numeralAttendee) => numeralAttendee.id === this.attendeeType.id).quantity
          : 0
        return stateAttendees
      },
      set (value) {
        this.numeralAttendees = { attendeeTypeId: this.attendeeType.id, quantity: parseInt(value) >= 0 ? parseInt(value) : 0 }
      },
    },
    maxAttendeesPerReservation () {
      return this.attendeeType.maxAttendeesPerReservation ? this.attendeeType.maxAttendeesPerReservation <= this.quantity : false
    },
  },
  methods:{
    add () {
      this.quantity++
    },
    remove () {
      this.quantity--
    },
  },
  mixins: [
    ReservationMixins,
  ],
}
</script>

<style scoped>
.card-counter {
  background-color: #F5F5F5;
}
.caption{
  min-height: 40px;
}
</style>
